var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "q-toolbar",
        { staticClass: "bg-white q-px-sm q-px-md-lg" },
        [
          !_vm.neutral
            ? _c("q-img", {
                staticClass: "logo",
                attrs: {
                  src:
                    "/typo3conf/ext/ig_warehouse/Resources/Public/Images/schorn-groh-furniere-veneers.svg",
                  basic: ""
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("q-space"),
          _vm._v(" "),
          _vm.user
            ? _c(
                "q-tabs",
                {
                  staticClass: "text-black",
                  attrs: {
                    align: "right",
                    "active-color": "primary",
                    dense: "",
                    shrink: ""
                  }
                },
                [
                  _c("q-route-tab", {
                    staticClass: "nav-tab q-px-sm",
                    class: _vm.isVeneerSearch,
                    attrs: {
                      to: { name: "products" },
                      label: _vm.$t("products")
                    }
                  }),
                  _vm._v(" "),
                  _c("q-route-tab", {
                    staticClass: "nav-tab q-px-sm",
                    attrs: {
                      to: { name: "watchlists" },
                      label: _vm.$t("watchlists")
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.user
            ? [
                _c(
                  "q-avatar",
                  {
                    staticClass: "q-ml-sm",
                    attrs: {
                      id: "top-avatar",
                      color: "primary",
                      "text-color": "white",
                      size: "2.5rem",
                      "font-size": "1rem"
                    }
                  },
                  [_vm._v(_vm._s(_vm.avatar))]
                ),
                _vm._v(" "),
                _c(
                  "q-menu",
                  { attrs: { target: "#top-avatar" } },
                  [
                    _c(
                      "q-list",
                      [
                        _c(
                          "q-item",
                          { attrs: { clickable: "" } },
                          [_c("q-item-section", [_c("language-switcher")], 1)],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "q-item",
                          { attrs: { clickable: "" } },
                          [
                            _c("q-item-section", [_c("zoho-authentication")], 1)
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "q-item",
                          { attrs: { clickable: "" } },
                          [
                            _c("q-item-section", [
                              _c(
                                "a",
                                { attrs: { href: "?logintype=logout" } },
                                [_vm._v(_vm._s(_vm.$t("button.logout")))]
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            : [_c("language-switcher", { attrs: { simple: "" } })]
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }